import React from 'react';
import AccountPage from '../account';

function PaymentPages() {
  return <AccountPage />;
}

export default PaymentPages;
